import styled from 'styled-components';
import { Pagination } from '@procore/core-react';
import { SectionTitle } from '../RestSections/styles';

export { SectionTitle };
export const StyledPagination = styled(Pagination)`
  float: right;
`;
